import { Outlet } from "react-router-dom";
type Props = {};

const Diagnostics = (props: Props) => {
  return <Outlet />;
};

export default Diagnostics;
